export default "__VITE_ASSET__1RDaUFUn__"